/**
 * @file crossSearch.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-03
 * @modified 2026-10-01
 */

import { revealInSearch } from './revealInSearch';

/**
 * "Where else does this item appear?" — the three screens worth asking.
 *
 * The code is handed over with revealInSearch, the same handoff every "Find in
 * …" uses, so the target opens with the code in the box, the search already
 * run, and the results from page 1. It used to write the target's filters slot
 * in the nav store directly: the term arrived, but the page number the user had
 * last left that screen on came with it — page 4 of a search with one page of
 * results is an empty table.
 *
 * `tab` is the tab of the page the list lives on (Sales Orders and Purchase
 * Orders both have a second tab the user may have left them on).
 */
export const CROSS_SEARCH_TARGETS = [
  {
    key: 'orders',
    menu: 'search-customer-orders',
    tab: 'orders',
    label: 'Search Orders',
    icon: 'shopping_cart',
    description: 'Customer orders containing this item'
  },
  {
    key: 'invoices',
    menu: 'search-invoices',
    label: 'Search Invoices',
    icon: 'receipt_long',
    description: 'Invoices and credit notes containing this item'
  },
  {
    key: 'purchase-orders',
    menu: 'search-purchase-orders',
    tab: 'orders',
    label: 'Search Purchase Orders',
    icon: 'local_shipping',
    description: 'Purchase orders containing this item'
  }
];

/**
 * Put the code in the target screen's search box, then go there.
 *
 * @returns {boolean} true when it navigated
 */
export function runCrossSearch(target, term, onNavigate) {
  if (!target) return false;
  return revealInSearch(onNavigate, target.menu, term, null, { tab: target.tab });
}
